import { Input } from "./ui/input";
import { Search, X } from "lucide-react";
import { Button } from "./ui/button";
import { TableTheme } from "../types";

export const GlobalFilter = ({
  globalFilter,
  setGlobalFilter,
  placeholder = "Search all columns...",
  theme,
}: {
  globalFilter: string;
  setGlobalFilter: (value: string) => void;
  placeholder?: string;
  theme: TableTheme;
}) => {
  return (
    <div className="relative">
      <Search
        className={`absolute left-3 top-1/2 transform -translate-y-1/2 ${theme.buttonSecondaryText} h-4 w-4`}
      />
      <Input
        type="text"
        placeholder={placeholder}
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        className={`pl-10 max-w-sm rounded-full ${theme.rowText} ${theme.rowEvenBg} ${theme.buttonSecondaryBorder}`}
      />
      {globalFilter && (
        <Button
          variant="ghost"
          size="sm"
          className={`absolute right-1 top-1/2 transform -translate-y-1/2 h-6 w-6 p-0 rounded-full ${theme.rowEvenBg} ${theme.buttonSecondaryText} ${theme.buttonSecondaryHover}`}
          onClick={() => setGlobalFilter("")}
        >
          <X className={`h-3 w-3 ${theme.buttonSecondaryText}`} />
        </Button>
      )}
    </div>
  );
};
